import { createSlice } from "@reduxjs/toolkit";
import Metadata from "ts/app/metadata";

const initialState = {
  hideSidebar: false,
  backPath: "",
  appBarBottomContent: {
    mainText: "",
    lastPage: "",
    showOptions: false,
    variant: "",
    tabs: {},
  },
  showBar: null,
} as Metadata;

const metadataSlice = createSlice({
  name: "metadata",
  initialState,
  reducers: {
    resetMetadata: () => initialState,
    updateMetadata: (state, { payload }: { payload: Partial<Metadata> }) => {
      return {
        ...state,
        ...payload,
      };
    },
    updateAppBarBottomContent: (state, { payload }) => ({
      ...state,
      appBarBottomContent: payload,
    }),
    resetAppBarBottomContent: (state) => ({
      ...state,
      hideSidebar: false,
      appBarBottomContent: {},
      showBar: null,
    }),
  },
});

export const {
  resetMetadata,
  updateAppBarBottomContent,
  updateMetadata,
  resetAppBarBottomContent,
} = metadataSlice.actions;

export default metadataSlice.reducer;
